import React from 'react';
import PropTypes from 'prop-types';

import './styles.scss';

const CardSendControlCenterListItem = ({ title, subtitle, status, action, children }) => {
  return (
    <div className="card-send-control-center-list-item-container">
      <div className="card-send-control-center-list-item">
        <div className="card-send-control-center-list-item-details">
          {title && <span className="list-item-title">{title}</span>}
          {subtitle && <span className="list-item-subtitle">{subtitle}</span>}
        </div>
        <div className="card-send-control-center-list-item-actions">
          {status && <span className="list-item-status">{status}</span>}
          {action && <span className="list-item-action">{action}</span>}
        </div>
      </div>
      {children}
    </div>
  );
}


CardSendControlCenterListItem.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  status: PropTypes.string,
  action: PropTypes.node,
  children: PropTypes.node
};

export default CardSendControlCenterListItem;
